import Layout from '@shared/layout/index.vue'
/**
 * 权限路由配置
 * name是cacheview的关键字段
 *
 * 配置路由自定义参数
 * hidden: 注册路由，但不显示在菜单中
 * alwaysShow: 没有权限也展示在菜单中
 *
 * hiddenSideBar: 隐藏左侧菜单栏
 */

export const permissionRoutes = [
  {
    path: '/sys',
    component: Layout,
    meta: {
      title: '系统管理',
      icon: '#icon-xitongguanli'
    },
    children: [
      {
        name: 'ViewMemberManagement',
        path: '/sys/member-management',
        component: () => import('@/views/gateway-auth/member-management/index.vue'),
        meta: { title: '成员管理', permissionStr: 'sys-user' }
      },
      {
        name: 'ViewRoles',
        path: '/sys/roles',
        component: () => import('@/views/gateway-auth/roles/index.vue'),
        meta: { title: '角色管理', permissionStr: 'sys-role' }
      },
      {
        name: 'ViewPermissionManagement',
        path: '/sys/permission-management',
        component: () => import('@/views/gateway-auth/permission-management/index.vue'),
        meta: { title: '权限管理', permissionStr: 'sys-perm' }
      },

      {
        name: 'ViewZoneManagement',
        path: '/sys/zone-management',
        component: () => import('@/views/gateway-auth/zone-management/index.vue'),
        meta: { title: '区域管理', permissionStr: 'sys-area' }
      },
      {
        name: 'ViewWorkManagement',
        path: '/sys/work-management',
        component: () => import('@/views/gateway-auth/work-management/index.vue'),
        meta: { title: '工作台', permissionStr: 'sys-work' }
      },
      {
        name: 'ViewAppManagement',
        path: '/sys/app-management',
        component: () => import('@/views/gateway-auth/app-management/index.vue'),
        meta: { title: '应用管理', permissionStr: 'sys-application' }
      },
      {
        name: 'ViewAPPProduct',
        path: '/sys/app-info-version',
        component: () => import('@/views/gateway-auth/app-info-version/index.vue'),
        meta: { title: 'APP版本管理', permissionStr: 'sys-app-version' }
      },
      {
        name: 'ViewMessageManagement',
        path: '/sys/message-management',
        component: () => import('@/views/gateway-auth/message-management/index.vue'),
        meta: { title: '消息管理', permissionStr: 'sys-message-config' }
      },
      {
        name: 'MachineOperatorLog',
        path: '/sys/machine-operator-log',
        component: () => import('@/views/gateway-auth/operation-log/index.vue'),
        meta: { title: '审计日志', permissionStr: 'sys-audit-log' }
      }
    ]
  }
]

export default [
  // {
  //   name: '首页',
  //   hiddenSideBar: true,
  //   routes: [
  //     {
  //       component: Layout,
  //       children: [
  //         {
  //           name: 'ViewHome',
  //           path: '/home',
  //           meta: {
  //             title: '首页',
  //             alwaysShow: true,
  //             icon: new URL('@/assets/images/permissions/permissions_home.png', import.meta.url).href
  //           },
  //           component: () => import('@/views/home/home/index.vue')
  //         }
  //       ]
  //     }
  //   ]
  // },
  {
    name: '工作台',
    hiddenSideBar: true,
    routes: [
      {
        component: Layout,
        children: [
          {
            name: 'ViewWork',
            path: '/work',
            meta: {
              title: '工作台1',
              alwaysShow: true,
              icon: new URL('@/assets/images/permissions/permissions_home.png', import.meta.url).href
            },
            component: () => import('@/views/home/work/index.vue')
          }
        ]
      }
    ]
  },
  { name: '系统管理', routes: permissionRoutes, showSystem: true }
]
